module.exports = __webpack_public_path__ + "img/search.a598218a.svg";